import { useConstantValueInvariant } from "@contember/react-utils";
import { useMemo } from "react";
function useEntitySubTreeParameters(qualifiedSingleEntity) {
  useConstantValueInvariant(typeof qualifiedSingleEntity);
  if (typeof qualifiedSingleEntity === "string") {
    return qualifiedSingleEntity;
  }
  useConstantValueInvariant(qualifiedSingleEntity.isCreating, `EntitySubTree: cannot alternate the 'isCreating' value.`);
  useConstantValueInvariant(typeof qualifiedSingleEntity.entity, `EntitySubTree: cannot alternate the 'entity' value.`);
  if (qualifiedSingleEntity.isCreating) {
    const entity2 = qualifiedSingleEntity.entity;
    if (typeof entity2 === "string") {
      return useMemo(
        () => ({
          isCreating: true,
          entity: entity2
        }),
        [entity2]
      );
    }
    return useMemo(
      () => ({
        isCreating: true,
        entity: { entityName: entity2.entityName }
      }),
      [entity2.entityName]
    );
  }
  const entity = qualifiedSingleEntity.entity;
  if (typeof entity === "string") {
    return useMemo(() => ({ entity }), [entity]);
  }
  return useMemo(
    () => ({
      entity: {
        entityName: entity.entityName,
        filter: entity.filter,
        where: entity.where
      }
    }),
    [entity.entityName, entity.filter, entity.where]
  );
}
export {
  useEntitySubTreeParameters
};
//# sourceMappingURL=useEntitySubTreeParameters.js.map
